import axios from 'axios';
import config from '@/configs/config';
import Cookies from 'js-cookie';
import { getDeviceId } from '@/helpers/deviceId';

const apiHeader = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor untuk menambahkan Bearer token pada setiap request
apiHeader.interceptors.request.use(
  config => {
    // Ambil token dari sessionStorage (scoped tab browser) atau legacy localStorage jika ada
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Tambahkan X-Device-ID pada setiap request agar backend dapat
    // mengidentifikasi perangkat yang digunakan
    config.headers['X-Device-ID'] = getDeviceId();

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Menangani Error secara Global
apiHeader.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Cek apakah response mengandung force_password_change
    if (error.response?.data?.data?.force_password_change === true) {
      // Redirect ke halaman force change password (token tetap disimpan)
      if (window.location.pathname !== '/force-change-password') {
        window.location = '/force-change-password';
      }
      return Promise.reject(error);
    }

    const status = error.response?.status;
    if (status === 401 || status === 403) {
      // Jangan bersihkan auth kalo masih proses SSO callback (flag sessionStorage)
      if (sessionStorage.getItem('ssoCallbackActive')) {
        return Promise.reject(error);
      }

      // Redirect ke halaman login dan bersihkan token
      sessionStorage.removeItem('token');
      localStorage.removeItem('token');
      localStorage.removeItem('userAuth');
      Cookies.remove('userAuth');

      // Hanya redirect ke halaman login jika user belum berada di sana
      if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
        const redirectPath = encodeURIComponent(window.location.pathname);
        window.location = `/login?redirect=${redirectPath}`;
      }
    }

    return Promise.reject(error);
  }
);

export default apiHeader;
